import {LOCALE_ID, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import {AppRoutingModule} from './app-routing.module';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {DatePipe, registerLocaleData, CommonModule } from '@angular/common';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import localeEs from '@angular/common/locales/es';
import { ENV } from 'environments/environment';

import { ButtonsModule } from '@fira/seed/dist/seed';

import { AppComponent } from './app.component';
import { ThemeModule } from './theme/theme.module';



export class CustomLoader implements TranslateLoader {
  constructor(private httpClient: HttpClient) {
  }

   getTranslation(translateFile: string) {
      // if (translateFile.includes('.json')) {
      //   return this.httpClient.get(translateFile);
      // } else {
      //   return this.httpClient.get(`${ENV.MEDIA_REPOSITORY}/${translateFile}.json`);
      // }
       return this.httpClient.get(`./assets/i18n/${translateFile}.json`);
  }


  b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    }
}

registerLocaleData(localeEs, 'es');


@NgModule({
  declarations: [
    AppComponent
    ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useClass: CustomLoader,
          deps: [HttpClient]
      }
  }),
    ButtonsModule,
    CommonModule,
    HttpClientModule,
    ThemeModule
  ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: 'es' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
